import { render } from "./ComingSoonB.vue?vue&type=template&id=06873312"
import script from "./ComingSoonB.vue?vue&type=script&lang=js"
export * from "./ComingSoonB.vue?vue&type=script&lang=js"

import "./ComingSoonB.vue?vue&type=style&index=0&id=06873312&lang=scss"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__